<div class="amount">
    <h1 class="whole" *ngIf="currency">{{currency | uppercase}} </h1>
    <h1 [class]="getWholeClass()">{{ formatWholeNumber(whole) }}</h1>
    <span *ngIf="fraction" [class]="getFractionClass()">{{ fraction }}</span>
</div>